import Api from './api'
import App from './app'
import SIP from './sip'
import Auth from './auth'

export default {
    app: App,
    api: Api,
    sip: SIP,
    auth: Auth,
}
